<template>
  <a-modal
    :title="title"
    centered
    :width="500"
    :mask-closable="false"
    :visible="showForm"
    :confirmLoading="loading"
    @cancel="close"
  >
    <a-form-model
      ref="form"
      :model="model"
      :rules="rules"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
      >
        <a-spin :spinning="loading">
          <template v-if="model.field == 'bid'">
            <a-form-model-item label="出价" prop="bid" >
              <a-input-number :min="0.01" :max="300" :precision="2" v-model="model.bid" style="width:300px" />
            </a-form-model-item>
          </template>

          <template v-if="model.field == 'roi_goal'">
            <a-form-model-item label="roi出价" prop="roi_goal" >
              <a-input-number :min="0.0001" :max="5" :precision="4" v-model="model.roi_goal" style="width:300px"/>
            </a-form-model-item>
          </template>
        </a-spin>
      </a-form-model>

    <template slot="footer">
      <a-button @click="close" :disabled="loading">取消</a-button>
      <a-button type="primary" @click="submit" :disabled="loading">确定</a-button>
    </template>
  </a-modal>
</template>

<style lang="less" scoped>
@import 'Create';
</style>

<script>
import Create from './Create'
export default Create
</script>
